import React from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "./Button";

/**
 * The chrome both research review screens wrap around their cards.
 *
 * Shared for the same reason `useResearchQueue` is: the two screens are one screen over different
 * records, and a fix to the toast, the spinner or the tab row should not have to be made twice.
 * What differs between them — the heading, the extra filters, the empty state, the cards — stays
 * on the page.
 */

export const RESEARCH_STATUS_TABS = [
  { value: "open", label: "Open" },
  { value: "resolved", label: "Resolved" },
  { value: "dismissed", label: "Dismissed" }
];

export function StatusTabs({ status, onChange, tabs = RESEARCH_STATUS_TABS }) {
  return tabs.map((tab) => (
    <Button
      key={tab.value}
      size="sm"
      variant={status === tab.value ? "default" : "outline"}
      onClick={() => onChange(tab.value)}
    >
      {tab.label}
    </Button>
  ));
}

export function QueueSpinner() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}

/**
 * Fixed, not inline: a banner in the flow pushes every card down the moment an accept lands,
 * which reads as the page jumping just as you go to click the next item.
 */
export function SuccessToast({ message }) {
  if (!message) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-md border bg-background p-3 text-sm shadow-lg"
    >
      <CheckCircle2 className="h-4 w-4" /> {message}
    </div>
  );
}
